<ng-container *ngIf="eftersynState" [ngSwitch]="eftersynState">
  <div class="flex-wrap flex-wrap--flex-start flex-wrap--align-center tiny-text">
    <ng-container *ngSwitchCase="eftersynStateEnum.NotCreated">
      <mat-icon svgIcon="thumb-down" class="red"></mat-icon>
      <i class="no-line-height">Eftersyn IKKE oprettet</i>
    </ng-container>
    <ng-container *ngSwitchCase="eftersynStateEnum.Created">
      <mat-icon svgIcon="point" class="orange"></mat-icon>
      <a [routerLink]="['/ordre', serviceordreNo, 'edit']" class="blue">
        <i class="no-line-height">Eftersyn oprettet</i>
      </a>
    </ng-container>
    <ng-container *ngSwitchCase="eftersynStateEnum.Completed">
      <mat-icon svgIcon="thumb-up" class="green"></mat-icon>
      <a [routerLink]="['/ordre', serviceordreNo, 'edit']" class="blue">
        <i class="no-line-height">Eftersyn gennemført</i>
      </a>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
  </div>
</ng-container>
